import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { HttpActions } from "@webapp/core/abstracts/enums/http-actions.enum";
import { ApiVersionModel } from "@webapp/core/abstracts/models/api-version.model";
import { BaseApiService } from "@webapp/core/abstracts/services/base-api.service";
import { APP_CONFIG, IAppConfig } from "@webapp/core/app-config/models/app-config.models";
import {
  IDeleteReflectionQuestionEndpointParams,
  IGetTeamReflectionEndpointParams,
  IPatchReflectionEndpointParams,
  IPatchReflectionQuestionEndpointParams,
  IPatchReflectionUpdateEndpointParams,
  IPostReflectionQuestionEndpointParams,
  IPostReflectionUpdateEndpointParams,
} from "../models/reflections-api.models";
import { Reflection, ReflectionDTO } from "../models/reflections.models";
import { ReflectionsState } from "./reflections-state.service";

@Injectable({
  providedIn: "root",
})
export class ReflectionsApiService extends BaseApiService<Reflection, ReflectionDTO, ReflectionsState> {
  constructor(httpClient: HttpClient, @Inject(APP_CONFIG) appConfig: IAppConfig, state: ReflectionsState) {
    super("reflections", { ...new ApiVersionModel("v1") }, httpClient, appConfig, state);
  }

  public getReflectionsEndpoint(): string {
    return `${this.getBasePath(HttpActions.get)}/`;
  }

  public getTeamReflectionEndpoint({ teamId }: IGetTeamReflectionEndpointParams): string {
    return `${this.getBasePath(HttpActions.get)}/teams/${teamId}`;
  }

  public patchReflectionEndpoint({ reflectionId }: IPatchReflectionEndpointParams): string {
    return `${this.getBasePath(HttpActions.patch)}/${reflectionId}`;
  }

  public getReflectionUpdatesEndpoint(): string {
    return `${this.getBasePath(HttpActions.get)}/updates`;
  }

  public postReflectionUpdateEndpoint({ reflectionId }: IPostReflectionUpdateEndpointParams): string {
    return `${this.getBasePath(HttpActions.post)}/${reflectionId}/updates`;
  }

  public patchReflectionUpdateEndpoint({ updateId, answerId }: IPatchReflectionUpdateEndpointParams): string {
    return `${this.getBasePath(HttpActions.patch)}/updates/${updateId}/answers/${answerId}`;
  }

  public postReflectionQuestionEndpoint({ reflectionId }: IPostReflectionQuestionEndpointParams): string {
    return `${this.getBasePath(HttpActions.post)}/${reflectionId}/questions`;
  }

  public patchReflectionQuestionEndpoint({ reflectionId, questionId }: IPatchReflectionQuestionEndpointParams): string {
    return `${this.getBasePath(HttpActions.patch)}/${reflectionId}/questions/${questionId}`;
  }

  public deleteReflectionQuestionEndpoint({ reflectionId, questionId }: IDeleteReflectionQuestionEndpointParams): string {
    return `${this.getBasePath(HttpActions.delete)}/${reflectionId}/questions/${questionId}`;
  }
}
